import { View } from 'backbone';
import { Model } from 'backbone';
import template from 'designer/left-panel-state-mandatory.ejs';
import listService from 'ListService';
import stageDropdown from 'designer/stages-dropdown.ejs';
import rolesDropdown from 'designer/roles-dropdown.ejs';
import thumbPageListUtil from 'util/ThumbPageListUtil.js';
import InputsByStageAndRole from 'common-views/InputsByStageAndRole';
import settingsService from 'MandatoryAndStateSettingsService';
import constants from 'Constants';
import eventBus from 'EventBus';

class StateAndMandatoryView extends View {

    initialize(opts) {
        this.options = opts || {};
        this.template = template;
        this.id = opts.el;
        this.values = opts.values;
        this.model.set('isForm', listService.docType === constants.DOC_TYPE_FORM, {silent:true});

        this.events = {
            'click  .select-stage': 'updateCurrentStage',
            'click  .select-role': 'updateCurrentRole',
            'click #view-state-modal': 'viewStateModal',
            'click #view-mandatory-modal': 'viewMandatoryModal'
        };

        return this;
    }

    viewStateModal(e) {
        e.preventDefault();
        const
            stage = listService.getCurrentStage(),
            role = listService.getCurrentRole(),
            modalSettings = {
                title: 'Object States Overview',
                emptyTitle: 'No objects in a non-mandatory state exist for this stage and role',
                options: constants.STATE_OPTIONS,
                settings: 'state',
                settingsValue: 'value',
                defaultValue: 'default',
                stage: stage,
                role: role,
                model: new Model(),
                filter: (val) => {
                    let controlHasNonDefaultSettings = false;
                    if ((val.model !== undefined && val.model.has('state') && val.model.get('factoryKey') !== 'layout_frame')) {
                        const controlSettings = {
                            stageId: stage,
                            roleId: role,
                            settings: val.model.get('state'),
                            defaultValue: 'default',
                            settingsField: 'value'
                        };
                        controlHasNonDefaultSettings = settingsService.getSetting(controlSettings) !== 'default';
                    }
                    if (val.model.get('factoryKey') === 'control_table') {
                        controlHasNonDefaultSettings = true;
                    }
                    return controlHasNonDefaultSettings;
                }


            };
        const modalView = new InputsByStageAndRole(modalSettings);
        modalView.render();
    }

    viewMandatoryModal(e) {
        e.preventDefault();
        const
            stage = listService.getCurrentStage(),
            role = listService.getCurrentRole(),
            modalSettings = {
                title: 'Mandatory Objects Overview',
                emptyTitle: 'No mandatory objects exist for this stage and role',
                options: constants.MANDATORY_OPTIONS,
                settings: 'mandatories',
                settingsValue: 'required',
                defaultValue: "all",
                stage: stage,
                role: role,
                model: new Model(),
                filter: (val) => {
                    let controlHasNonDefaultSettings = false;
                    if (val.model !== undefined && val.family === 'common_input') {
                        const controlSettings = {
                            stageId: stage,
                            roleId: role,
                            settings: val.model.get('mandatories'),
                            defaultValue: "all",
                            settingsField: 'required'
                        };
                        controlHasNonDefaultSettings = settingsService.getSetting(controlSettings).toLowerCase() === "all" ||
                            settingsService.getSetting(controlSettings).toLowerCase() === "no" ||
                            settingsService.getSetting(controlSettings).toLowerCase() === "yes";
                    }
                    if (val.model.get('factoryKey') === 'control_table') {
                        controlHasNonDefaultSettings = true;
                    }
                    return controlHasNonDefaultSettings;
                }
            };
        const modalView = new InputsByStageAndRole(modalSettings);
        modalView.render();
    }

    updateCurrentStage(e) {
        e.preventDefault();
        const newStage = e.currentTarget.getAttribute('data-stage-id');
        if (newStage) {
            listService.setCurrentStage(newStage);
            eventBus.trigger(constants.EV_CURRENT_ROLE_OR_STAGE_UPDATED);
            this.updateStageAndRoles();
        }
    }

    updateCurrentRole(e) {
        e.preventDefault();
        const newRole = e.currentTarget.getAttribute('data-role-id');
        if (newRole) {
            listService.setCurrentRole(newRole);
            eventBus.trigger(constants.EV_CURRENT_ROLE_OR_STAGE_UPDATED);
            this.updateStageAndRoles();
        }
    }

    updateStageAndRoles(model) {

        const values = model || thumbPageListUtil.getViewValues(this.model);

        $('#stagesDropdown').empty();
        $('#stagesDropdown').append(stageDropdown(values));

        $('#rolesDropdown').empty();
        $('#rolesDropdown').append(rolesDropdown(values));
    }

    updateFormBehaviors() {
        const factoryKey = this.model.get('isForm') ? 'layout_frame' : 'reports_frame';
        let page = 'aform';
        let behaviors = thumbPageListUtil.getBehaviorsListForControl(factoryKey, page);
        const newUlTree = $('#behavior-page-aform ul');

        newUlTree.append(behaviors);
    }

    


    render() {

        if (this.template) {
            this.$el.html(this.template(this.model.toJSON()));
        }

        this.updateStageAndRoles(this.values);
        this.updateFormBehaviors();
        
        this.delegateEvents();
    }
}
export default StateAndMandatoryView;